import React from "react";
import { Box, Typography, Button, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RootContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "100vh",
  display: "grid",
  placeContent: "center",
}));

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    navigate("/auth/");
  };
  
  return (
    <RootContainer>
      <Typography
        sx={{ fontSize: { xs: "20px !important", md: "28px !important" } }}
      >
        404 <span>|</span> {t("page_not_found_text")}
      </Typography>
      <Button
        variant="contained"
        onClick={handleClick}
        sx={{ mt: 2, mx: "auto", height: 45 }}
      >
        {t("page_not_found_backhome")}
      </Button>
    </RootContainer>
  );
};
